<div class="aca-mig__toolbar">
  <button type="button" class="aca-mig__btn aca-mig__btn--primary" (click)="add()">
    <mat-icon>add</mat-icon>{{ 'DMS.MIGRATION.ADD_CONNECTION' | translate }}
  </button>
  <span class="aca-mig__spacer"></span>
  <span class="aca-mig__hint">{{ 'DMS.MIGRATION.CONN_SECRETS_NOTE' | translate }}</span>
</div>

<section class="aca-mig__card">
  <div class="aca-mig__empty" *ngIf="!loading && !connections().length">
    <mat-icon>cable</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.EMPTY_CONN_TITLE' | translate }}</div>
    <div>{{ 'DMS.MIGRATION.EMPTY_CONN_DESC' | translate }}</div>
    <button type="button" class="aca-mig__btn aca-mig__btn--primary" (click)="add()">
      <mat-icon>add</mat-icon>{{ 'DMS.MIGRATION.ADD_CONNECTION' | translate }}
    </button>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="connections().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_NAME' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_CONNECTOR' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_TARGET' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_CREATED' | translate }}</th>
          <th class="aca-mig__th" style="text-align: right">{{ 'DMS.MIGRATION.COL_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let conn of connections(); trackBy: trackById" [style.opacity]="conn.enabled ? 1 : 0.55">
          <td class="aca-mig__td">
            <span style="display: inline-flex; align-items: center; gap: 8px">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px">{{ connectorIcon(conn.connectorId) }}</mat-icon>
              <strong>{{ conn.name }}</strong>
            </span>
          </td>
          <td class="aca-mig__td">{{ connectorName(conn.connectorId) }}</td>
          <td class="aca-mig__td aca-mig__mono">{{ targetOf(conn) }}</td>
          <td class="aca-mig__td">
            <span class="aca-mig__chip" [ngClass]="conn.enabled ? 'aca-mig__chip--ok' : ''">
              {{ (conn.enabled ? 'DMS.MIGRATION.ST_ENABLED' : 'DMS.MIGRATION.ST_DISABLED') | translate }}
            </span>
          </td>
          <td class="aca-mig__td">{{ dateLabel(conn.createdAt) }}</td>
          <td class="aca-mig__td" style="text-align: right; white-space: nowrap">
            <button
              type="button"
              class="aca-mig__iconbtn"
              [disabled]="busyId() === conn.id || api.available() !== true"
              [matTooltip]="api.available() === true ? ('DMS.MIGRATION.TEST_CONNECTION' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              [attr.aria-label]="
                api.available() === true ? ('DMS.MIGRATION.TEST_CONNECTION' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)
              "
              (click)="test(conn)"
            >
              <mat-icon>network_check</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              [disabled]="busyId() === conn.id"
              [matTooltip]="(conn.enabled ? 'DMS.MIGRATION.DISABLE' : 'DMS.MIGRATION.ENABLE') | translate"
              [attr.aria-label]="(conn.enabled ? 'DMS.MIGRATION.DISABLE' : 'DMS.MIGRATION.ENABLE') | translate"
              (click)="toggle(conn)"
            >
              <mat-icon>{{ conn.enabled ? 'toggle_on' : 'toggle_off' }}</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              [disabled]="busyId() === conn.id"
              [matTooltip]="'DMS.MIGRATION.EDIT' | translate"
              [attr.aria-label]="'DMS.MIGRATION.EDIT' | translate"
              (click)="edit(conn)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              [disabled]="busyId() === conn.id"
              [matTooltip]="'DMS.MIGRATION.DELETE' | translate"
              [attr.aria-label]="'DMS.MIGRATION.DELETE' | translate"
              (click)="remove(conn)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
